export const productVariantMenuTestIds = {
    open: 'ProductVariantMenu.Open',
    archive: 'ProductVariantMenu.Archive',
} as const;
